const THREE_WINDING_BASE_ALIAS = 'transfomador-de-3-devanados-Base';
const SWITCH_TRANSFER_BASE_ALIAS = 'switchdetransferencia';
const SWITCH_ALIAS = 'switch';
const INTERRUPTOR_MT_AT_A_ALIAS = 'interruptor-mtat-a';
const UTILITY_B_ALIAS = 'utility-b';

const THREE_WINDING_IMAGE = '/assets/editor-symbols/TransformadorTresDevanadosBase.svg';
const SWITCH_TRANSFER_IMAGE = '/assets/editor-symbols/SwitchDeTransferencia.svg';
const SWITCH_IMAGE = '/assets/editor-symbols/Switch.svg';
const INTERRUPTOR_MT_AT_A_IMAGE = '/assets/editor-symbols/InterruptorMT_ATSimbolo1.svg';
const UTILITY_B_IMAGE = '/assets/editor-symbols/UtilitySimbolo2.svg';

const THREE_WINDING_SOURCE_HANDLE_FRACTIONS = [0.235 , 0.77];
const SWITCH_TRANSFER_TARGET_HANDLE_FRACTIONS = [0.2501, 0.745];
const SWITCH_TRANSFER_SOURCE_HANDLE_FRACTIONS = [0.5];

export const resolveThreeWindingImage = () =>
  THREE_WINDING_IMAGE;

export const resolveThreeWindingHandleFraction = (index, count) => {
  const total = Math.max(1, Number(count) || 1);
  const rawIndex = Number(index);
  const normalizedIndex = Number.isFinite(rawIndex)
    ? Math.min(total - 1, Math.max(0, rawIndex))
    : 0;

  if (total === THREE_WINDING_SOURCE_HANDLE_FRACTIONS.length) {
    return THREE_WINDING_SOURCE_HANDLE_FRACTIONS[normalizedIndex];
  }

  return total <= 1 ? 0.5 : normalizedIndex / (total - 1);
};

export const resolveSwitchTransferImage = () =>
  SWITCH_TRANSFER_IMAGE;

export const resolveSwitchTransferHandleFraction = (role, index, count) => {
  const fractions = role === 'source'
    ? SWITCH_TRANSFER_SOURCE_HANDLE_FRACTIONS
    : SWITCH_TRANSFER_TARGET_HANDLE_FRACTIONS;
  const total = Math.max(1, Number(count) || 1);
  const rawIndex = Number(index);
  const normalizedIndex = Number.isFinite(rawIndex)
    ? Math.min(total - 1, Math.max(0, rawIndex))
    : 0;

  if (total === fractions.length) {
    return fractions[normalizedIndex];
  }

  return total <= 1 ? 0.5 : normalizedIndex / (total - 1);
};

export const resolveSwitchImage = () =>
  SWITCH_IMAGE;

export const resolveInterruptorMtAtAImage = () =>
  INTERRUPTOR_MT_AT_A_IMAGE;

export const resolveUtilityBImage = () =>
  UTILITY_B_IMAGE;

export {
  THREE_WINDING_BASE_ALIAS,
  SWITCH_TRANSFER_BASE_ALIAS,
  SWITCH_ALIAS,
  INTERRUPTOR_MT_AT_A_ALIAS,
  UTILITY_B_ALIAS
};
